
const defaultUrlPlaceholder = 'https://www.beusable.net'
const urlLabelKey = 'common.matchType.urlLabel'
const domainLabelKey = 'common.domain'

export const matchTypeOptions = [
  {
    value: 'exact',
    text: 'Exact Match',
    labelKey: urlLabelKey,
    urlPlaceholder: 'https://www.beusable.net/signup/?x=1',
    requireDomain: false,
    validationType: 'url'
  },
  {
    value: 'simple',
    text: 'Simple Match',
    labelKey: urlLabelKey,
    urlPlaceholder: 'https://www.beusable.net/',
    requireDomain: false,
    validationType: 'url'
  },
  {
    value: 'start',
    text: 'Starts Match',
    labelKey: urlLabelKey,
    urlPlaceholder: 'https://www.beusable.net/signup/',
    requireDomain: false,
    validationType: 'captureUrl'
  },
  {
    value: 'end',
    text: 'Ends Match',
    labelKey: domainLabelKey,
    urlPlaceholder: defaultUrlPlaceholder,
    matchStringLabelKey: 'common.matchType.endsMatchStringLabel',
    matchStringPlaceholder: '/signup',
    requireDomain: true,
    validationType: 'captureUrl'
  },
  {
    value: 'contains',
    text: 'Contains Match',
    labelKey: domainLabelKey,
    urlPlaceholder: defaultUrlPlaceholder,
    matchStringLabelKey: 'common.matchType.containsMatchStringLabel',
    matchStringPlaceholder: '?x=1',
    requireDomain: true,
    validationType: 'captureUrl'
  },
  {
    value: 'regexp',
    text: 'Regular Expression',
    labelKey: domainLabelKey,
    urlPlaceholder: defaultUrlPlaceholder,
    matchStringLabelKey: 'common.matchType.regExpMatchStringLabel',
    matchStringPlaceholder: '\\/pages\\/[^\\/]+',
    requireDomain: true,
    validationType: 'captureUrl'
  }
]

export const stepData = {
  '1': {
    titleKey: 'page.registration.step1.title'
  },
  '2': {
    titleKey: 'page.registration.step2.title'
  },
  '3': {
    titleKey: 'page.registration.optional.title',
    isOptional: true
  },
  '4': {
    titleKey: 'page.registration.preview.title',
    isOptional: true
  }
}

export const MAX_STEP = Object.keys(stepData).length
export const URL_STATE = {
  unvalidated: 0,
  valid: 1,
  invalid: -1,
  abExist: -2,
  overLap: -3
}
export const CAPTURE_STATE = {
  none: 0,
  failed: -1,
  waiting: 1,
  processing: 2,
  done: 3
}
export const CAPTURE_SUCCESS = 10

export function getHostname (url) {
  return url.replace(/^https?:\/\//i, '').split('/')[0]
}

export function removeWww (url) {
  return url.replace(/^www\./i, '')
}

export function getOriginFromUrl (url) {
  let origin = url.replace('//', '@@').split('/')[0].replace('@@', '//')
  origin = origin.replace(/80:$/, '')
  return origin
}
